import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import React, { useContext } from "react";
import Blogs from "../Blogs/Blogs";
import Button from '../UI/Button';
import { useNavigate } from "react-router-dom";

const BlogSection = () => {
    const navigate = useNavigate();
    const profileData = useContext(BioContext);
    const theme = useContext(ThemeContext);
    const blogs = profileData.Blogs;
    let topThreeBlogs = [];

    for (let j = blogs.length-1; j>=0 && j > blogs.length-4; j--){
        topThreeBlogs.push(blogs[j]);
    }
    
    return (
        <section style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}> 
        <h2 className="sectionHeading">BLOGS</h2>
        {topThreeBlogs.length>0 && 
        <div> 
            <Blogs blogs={topThreeBlogs}/>
            <div className="viewMore">
            <Button className="btn-viewMore" onClick={()=>window.open('https://blog.shahbazkhan.in/')} buttonTitle="VIEW ALL"/>
            </div>
        </div>
        }
        {topThreeBlogs.length===0 && <h3>Nothing to show!</h3>}
        </section>
     );
}
 
export default BlogSection;